import { userConstants } from "../_constants";
import { userService } from "../_services";
import { alertActions, professionalAction } from "./";
import { faceSearchService } from "../_services/face.search.service";
import { history } from "../_helpers";
import { isValidLoginResponse } from "../_helpers/auth";
import { message } from "antd";

export const userActions = {
  login,
  logout,
  getAll,
  createUser,
  getAdminUsers,
  updateUser,
  getAppUsers,
  updateAppUser,
  getAppUserTokens,
  getIPLogs,
  allOfficerUsers,
  mergeOfficerUsers,
  mergeOfficeUserList,
  findCityWiseUsers,
  UserHeartbeat,
  UserLogout,
  saveMapAdminCity,
  findMapAdminCity,
};

const GagDetectionCityId = async (cityId) => {
  try {
    if (!cityId || cityId === "0") {
      console.log("No valid cityId found, skipping API calls.");
      localStorage.setItem("gangDetection", "");
      return;
    }

    const verificationResponse =
      await professionalAction.AllocatedGagDetectionCityId(cityId);
    if (!verificationResponse.ok) {
      throw new Error(
        `Error fetching verification allocation: ${verificationResponse.statusText}`,
      );
    }
    const verificationText = await verificationResponse.text();
    const module = JSON.parse(verificationText);

    localStorage.setItem("gangDetection", JSON.stringify(module?.data[0]));
  } catch (err) {
    console.error("API Error:", err.message);
  }
};

const getAllocatedImageProvisionByCity = async (cityId) => {
  try {
    if (!cityId || cityId === "0") {
      console.log("No valid cityId found, skipping API calls.");
      localStorage.setItem("image_provision", "");
      return;
    }

    const provisonResponse =
      await professionalAction.getAllocatedImageProvisionByCity(cityId);
    if (!provisonResponse.ok) {
      throw new Error(
        `Error fetching image provison  allocation: ${provisonResponse.statusText}`,
      );
    }
    const provisonText = await provisonResponse.text();
    const provisioned = JSON.parse(provisonText) === true;

    localStorage.setItem("image_provision", provisioned ? "true" : "");
  } catch (err) {
    console.error("API Error:", err.message);
    localStorage.setItem("image_provision", "");
  }
};

const getVerificationAndAppUsers = async (cityId) => {
  try {
    if (!cityId || cityId === "0") {
      console.log("No valid cityId found, skipping API calls.");
      localStorage.setItem("allocatedVerification", "");
      return;
    }

    const verificationResponse =
      await professionalAction.getVerificationAllocation(cityId);
    if (!verificationResponse.ok) {
      throw new Error(
        `Error fetching verification allocation: ${verificationResponse.statusText}`,
      );
    }
    const verificationText = await verificationResponse.text();
    const module = JSON.parse(verificationText);

    localStorage.setItem(
      "allocatedVerification",
      JSON.stringify(module?.data[0]),
    );

    if (module?.data[0]?.plan === "Plan C") {
      const appUsersResponse = await professionalAction.getAppUsers(cityId);
      if (!appUsersResponse.ok) {
        throw new Error(
          `Error fetching app users: ${appUsersResponse.statusText}`,
        );
      }
      const appUsersText = await appUsersResponse.text();
      const appUsers = JSON.parse(appUsersText);

      localStorage.setItem("appUsers", JSON.stringify(appUsers.data));
    }
  } catch (err) {
    console.error("API Error:", err.message);
  }
};
const citieswiseFaceSearchAllocation = async (cityId) => {
  try {
    if (!cityId || cityId === "0") {
      console.log("No valid cityId found, skipping API calls.");
      localStorage.setItem("faceSearchAllocation", "");
      return;
    }

    const response =
      await faceSearchService.citieswiseFaceSearchAllocation(cityId);
    if (!response || !response.length) {
      localStorage.setItem("faceSearchAllocation", "");
      return;
    }

    console.log("face response", response);
    localStorage.setItem("faceSearchAllocation", JSON.stringify(response[0]));
  } catch (error) {
    console.error("API Error:", error.message);
    localStorage.setItem("faceSearchAllocation", "");
  }
};

function login(userid, password, phone, ipAddress, token) {
  return (dispatch) => {
    dispatch(request({ userid }));

    userService.login(userid, password, phone, ipAddress, token).then(
      (user) => {
        if (!isValidLoginResponse(user)) {
          dispatch(failure("Invalid login response"));
          message.error("Login failed. Please check your credentials.");
          return;
        }

        console.log("user", user);
        dispatch(success(user));
        localStorage.setItem("cityId", user.cityId);
        getVerificationAndAppUsers(user.cityId);
        GagDetectionCityId(user.cityId);
        getAllocatedImageProvisionByCity(user.cityId);
        citieswiseFaceSearchAllocation(user.cityId);

        setTimeout(() => {
          history.push("/");
        }, 1200);
      },
      (error) => {
        console.log("error", error);
        dispatch(failure(error));
        message.error(
          typeof error === "string" ? error : "Login failed. Please try again.",
        );
      },
    );
  };
  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function getAll(cityId, role) {
  return (dispatch) => {
    dispatch(request());
    userService.getAll(cityId, role).then(
      (users) => dispatch(success(users)),
      (error) => dispatch(failure(error)),
    );
  };
  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GETALL_SUCCESS, users };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

function getAdminUsers(role) {
  return (dispatch) => {
    dispatch(request());
    userService.getAdminUsers(role).then(
      (users) => dispatch(success(users)),
      (error) => dispatch(failure(error)),
    );
  };
  function request() {
    return { type: userConstants.GET_ADMIN_USER_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GET_ADMIN_USER_SUCCESS, users };
  }
  function failure(error) {
    return { type: userConstants.GET_ADMIN_USER_FAILURE, error };
  }
}

function getAppUsers(cityId) {
  return (dispatch) => {
    dispatch(request());
    userService.getAppUsers(cityId).then(
      (users) => dispatch(success(users)),
      (error) => dispatch(failure(error)),
    );
  };
  function request() {
    return { type: userConstants.GET_APP_USER_REQUEST };
  }
  function success(appuser) {
    return { type: userConstants.GET_APP_USER_SUCCESS, appuser };
  }
  function failure(error) {
    return { type: userConstants.GET_APP_USER_FAILURE, error };
  }
}

function createUser(data) {
  return (dispatch) => {
    userService.createUser(data).then(
      (user) => {
        dispatch(success(user));
        // history.push('/');
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };
  function request(newUser) {
    return { type: userConstants.CREATE_USER_REQUEST, newUser };
  }
  function success(newUser) {
    return { type: userConstants.CREATE_USER_SUCCESS, newUser };
  }
  function failure(error) {
    return { type: userConstants.CREATE_USER_FAILURE, error };
  }
}

function updateUser(data, id) {
  let reqObj = {
    ...data,
    id,
  };
  return (dispatch) => {
    userService.updateUser(data, id).then(
      (updatedUser) => {
        dispatch(success(reqObj));
        console.log(reqObj);
        // history.push('/');
        message.success("नवीन वापरकर्ता जोडा  Update Successfully !!!");
      },
      (error) => {
        dispatch(failure(error));
        message.error("Old Passwatd not used again!");
      },
    );
  };
  function request(updatedUser) {
    return { type: userConstants.UPDATE_USER_REQUEST, updatedUser };
  }
  function success(updatedUser) {
    return { type: userConstants.UPDATE_USER_SUCCESS, updatedUser };
  }
  function failure(error) {
    return { type: userConstants.UPDATE_USER_FAILURE, error };
  }
}

function updateAppUser(data, id) {
  let reqObj = {
    ...data,
    id,
  };

  return (dispatch) => {
    dispatch(request());
    userService.updateAppUser(data, id).then(
      (updatedUser) => {
        dispatch(success(reqObj));
        // history.push('/');
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };
  function request(updatedAppUser) {
    return { type: userConstants.UPDATE_APP_USER_REQUEST, updatedAppUser };
  }
  function success(updatedAppUser) {
    return { type: userConstants.UPDATE_APP_USER_SUCCESS, updatedAppUser };
  }
  function failure(error) {
    return { type: userConstants.UPDATE_APP_USER_FAILURE, error };
  }
}

function getAppUserTokens(cityId) {
  return userService.getAppUserTokens(cityId);
}

function getIPLogs(userid) {
  return (dispatch) => {
    dispatch(request());
    userService.getIPLogs(userid).then(
      (ip_logs) => dispatch(success(ip_logs)),
      (error) => dispatch(failure(error)),
    );
  };
  function request() {
    return { type: userConstants.IPLOGS_REQUEST };
  }
  function success(ip_logs) {
    return { type: userConstants.IPLOGS_SUCCESS, ip_logs };
  }
  function failure(error) {
    return { type: userConstants.IPLOGS_FAILURE, error };
  }
}

function allOfficerUsers() {
  return userService.allOfficerUsers();
}

function mergeOfficerUsers(data, id) {
  return userService.mergeOfficerUsers(data, id);
}
function mergeOfficeUserList() {
  return userService.mergeOfficeUserList();
}
function findCityWiseUsers(cityId) {
  return userService.findCityWiseUsers(cityId);
}
function UserHeartbeat(values) {
  return userService.UserHeartbeat(values);
}
function UserLogout(values) {
  return userService.UserLogout(values);
}
function saveMapAdminCity(value) {
  return userService.saveMapAdminCity(value);
}

function findMapAdminCity() {
  return userService.findMapAdminCity();
}
